import { NgModule } from "@angular/core";
import { FroalaEditorModule, FroalaViewModule } from "angular-froala-wysiwyg";
import { IonicModule } from "ionic-angular";
import { IonTagsInputModule } from "ionic-tags-input";
import { TooltipsModule } from "ionic-tooltips";
import { DirectivesModule } from "../directives/directives.module";
import { FilterArrayPipe } from "../pipes/filter-array/filter-array.pipe";
import { PipesModule } from "../pipes/pipes.module";
import { XlsApiPipe } from "../pipes/xls-api/xls-api";
import { AmountDiscountComponent } from "./amount-discount/amount-discount";
import { ColorComponent } from "./color/color";
import { DaysAvailabilityFormComponent } from "./days-availability-form/days-availability-form";
import { EventStaffAgendaComponent } from "./event-staff-agenda/event-staff-agenda";
import { SpeakerAgendaFormComponent } from "./event-staff-agenda/speaker-agenda-form/speaker-agenda-form";
import { FooterSuggestionComponent } from "./footer-suggestion/footer-suggestion";
import { GalleryResourceFormComponent } from "./gallery-resource-form/gallery-resource-form";
import { HistoryComponent } from "./history/history";
import { IconComponent } from "./icon/icon";
import { ImportXlsxComponent } from "./import-xlsx/import-xlsx.component";
import { LanguageFlagComponent } from "./language-flag/language-flag";
import { LoaderListComponent } from "./loader-list/loader-list";
import { MenuProfileComponent } from "./menu-profile/menu-profile";
import { NotFoundComponent } from "./not-found/not-found";
import { PercentageInputComponent } from "./percentage-input/percentage-input";
import { ProgressBarComponent } from "./progress-bar/progress-bar";
import { PurchasesListComponent } from "./purchases-list/purchases-list";
import { PurchasesLogComponent } from "./purchases-log/purchases-log";
import { PurchasesProductComponent } from "./purchases-product/purchases-product";
import { SelectCategoriesComponent } from "./select-categories/select-categories";
import { SelectModalComponent } from "./select-modal/select-modal";
import { StateListComponent } from "./state-list/state-list";
import { ToolbarLanguageComponent } from "./toolbar-language/toolbar-language";
import { UploadFileComponent } from "./upload-file/upload-file";
import { ValidateFormComponent } from "./validate-form/validate-form";
import { WidgetsRightComponent } from "./widgets-right/widgets-right";
import { WidgetsRightFormComponent } from "./widgets-right/widgets-right-form/widgets-right-form";

export const COMPONENTS = [
  MenuProfileComponent,
  PurchasesListComponent,
  LoaderListComponent,
  LanguageFlagComponent,
  UploadFileComponent,
  ValidateFormComponent,
  StateListComponent,
  ColorComponent,
  IconComponent,
  ImportXlsxComponent,
  ProgressBarComponent,
  NotFoundComponent,
  HistoryComponent,
  SelectModalComponent,
  PurchasesLogComponent,
  PurchasesProductComponent,
  ToolbarLanguageComponent,
  FooterSuggestionComponent,
  WidgetsRightComponent,
  WidgetsRightFormComponent,
  EventStaffAgendaComponent,
  SpeakerAgendaFormComponent,
  SelectCategoriesComponent,
  GalleryResourceFormComponent,
  DaysAvailabilityFormComponent,
  AmountDiscountComponent,
  PercentageInputComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  imports: [
    IonicModule,
    PipesModule,
    TooltipsModule,
    IonTagsInputModule,
    FroalaEditorModule,
    FroalaViewModule,
    DirectivesModule,
  ],
  providers: [
    XlsApiPipe,
    FilterArrayPipe,
  ],
})
export class SharedComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/shared-components.module.ts